import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
const Headline = ({ title, type, layout, spaceBottom = true, color = '#000', }) => {
    const HeadingTag = type;
    return (title && (_jsx(HeadingTag, { className: `headline${layout ? ` title--${layout}` : ''}`, style: spaceBottom ? { color } : { marginBottom: '0', color }, children: title })));
};
export default Headline;
